import { render, staticRenderFns } from "./Conferencia.vue?vue&type=template&id=64f0ed8a"
import script from "./Conferencia.vue?vue&type=script&lang=js"
export * from "./Conferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports